//adjectives that either aren't covered by rules, or have superlative/comparative forms
//this list is the seed, from which various forms are conjugated
module.exports= [
    "colonial",
    "moody",
    "literal",
    "actual",
    "probable",
    "apparent",
    "usual",
    "aberrant",
    "ablaze",
    "able",
    "absolute",
    "aboard",
    "abrupt",
    "absent",
    "absorbing",
    "abundant",
    "accurate",
    "adult",
    "afraid",
    "agonizing",
    "ahead",
    "aloof",
    "amazing",
    "arbitrary",
    "arrogant",
    "asleep",
    "astonishing",
    "average",
    "awake",
    "aware",
    "awkward",
    "back",
    "bad",
    "bankrupt",
    "bawdy",
    "beneficial",
    "bent",
    "best",
    "better",
    "bizarre",
    "bloody",
    "bouncy",
    "brilliant",
    "broken",
    "burly",
    "busy",
    "cagey",
    "careful",
    "caring",
    "certain",
    "chief",
    "chilly",
    "civil",
    "clever",
    "closed",
    "cloudy",
    "colossal",
    "commercial",
    "common",
    "complete",
    "complex",
    "concerned",
    "concrete",
    "congruent",
    "constant",
    "cooing",
    "correct",
    "cowardly",
    "craven",
    "cuddly",
    "daily",
    "damaged",
    "damaging",
    "dapper",
    "dashing",
    "deadpan",
    "deeply",
    "defiant",
    "degenerate",
    "delicate",
    "delightful",
    "desperate",
    "determined",
    "didactic",
    "difficult",
    "discreet",
    "done",
    "double",
    "doubtful",
    "downtown",
    "dreary",
    "east",
    "eastern",
    "elderly",
    "elegant",
    "elfin",
    "elite",
    "eminent",
    "encouraging",
    "entire",
    "erect",
    "ethereal",
    "exact",
    "expert",
    "extra",
    "exuberant",
    "exultant",
    "false",
    "fancy",
    "faulty",
    "female",
    "fertile",
    "fierce ",
    "financial",
    "first",
    "fit",
    "fixed",
    "flagrant",
    "foamy",
    "foolish",
    "foregoing",
    "foreign",
    "former",
    "fortunate",
    "frantic",
    "freezing",
    "frequent",
    "fretful",
    "friendly",
    "fun",
    "furry",
    "future",
    "gainful",
    "gaudy",
    "giant",
    "giddy",
    "gigantic",
    "gleaming",
    "global",
    "gold",
    "gone",
    "good",
    "goofy",
    "graceful",
    "grateful",
    "gratis",
    "gray",
    "grey",
    "groovy",
    "gross",
    "guarded",
    "half",
    "handy",
    "hanging",
    "hateful",
    "heady",
    "heavenly",
    "hellish",
    "helpful",
    "hesitant",
    "highfalutin",
    "homely",
    "honest",
    "huge",
    "humdrum",
    "hurried",
    "hurt",
    "icy",
    "ignorant",
    "ill",
    "illegal",
    "immediate",
    "immense",
    "imminent",
    "impartial",
    "imperfect",
    "imported",
    "initial",
    "innate",
    "inner",
    "inside",
    "irate",
    "jolly",
    "juicy",
    "junior",
    "juvenile",
    "kaput",
    "kindly",
    "knowing",
    "labored",
    "languid",
    "latter",
    "learned",
    "left",
    "legal",
    "lethal",
    "level",
    "lewd",
    "likely",
    "literate",
    "lively",
    "living",
    "lonely",
    "longing",
    "loutish",
    "lovely",
    "loving",
    "lowly",
    "luxuriant",
    "lying",
    "macabre",
    "madly",
    "magenta",
    "main",
    "major",
    "makeshift",
    "male",
    "mammoth",
    "measly",
    "meaty",
    "medium",
    "mere",
    "middle",
    "miniature",
    "minor",
    "miscreant",
    "mobile",
    "moldy",
    "mute",
    "naive",
    "nearby",
    "necessary",
    "neighborly",
    "next",
    "nimble",
    "nonchalant",
    "nondescript",
    "nonstop",
    "north",
    "nosy",
    "obeisant",
    "obese",
    "obscene",
    "observant",
    "obsolete",
    "offbeat",
    "official",
    "ok",
    "open",
    "opposite",
    "organic",
    "outdoor",
    "outer",
    "outgoing",
    "oval",
    "over",
    "overall",
    "overt",
    "overweight",
    "overwrought",
    "painful",
    "past",
    "peaceful",
    "perfect",
    "petite",
    "picayune",
    "placid",
    "plant",
    "pleasant",
    "polite",
    "potential",
    "pregnant",
    "premium",
    "present",
    "pricey",
    "prickly",
    "primary",
    "prior",
    "private",
    "profuse",
    "proper",
    "public",
    "pumped",
    "puny",
    "quack",
    "quaint",
    "quickest",
    "rabid",
    "racial",
    "ready",
    "real",
    "rebel",
    "recondite",
    "redundant",
    "relevant",
    "remote",
    "resolute",
    "resonant",
    "right",
    "rightful",
    "ritzy",
    "robust",
    "romantic",
    "roomy",
    "rough",
    "royal",
    "salty",
    "same",
    "scary",
    "scientific",
    "screeching",
    "second",
    "secret",
    "secure",
    "sedate",
    "seemly",
    "selfish",
    "senior",
    "separate",
    "severe",
    "shiny",
    "shocking",
    "shut",
    "shy",
    "sick",
    "significant",
    "silly",
    "sincere",
    "single",
    "skinny",
    "slight",
    "slimy",
    "smelly",
    "snobbish",
    "social",
    "somber",
    "sordid",
    "sorry",
    "southern",
    "spare",
    "special",
    "specific",
    "spicy",
    "splendid",
    "squeamish",
    "standard",
    "standing",
    "steadfast",
    "steady",
    "stereotyped",
    "still",
    "striped",
    "stupid",
    "sturdy",
    "subdued",
    "subsequent",
    "substantial",
    "sudden",
    "super",
    "superb",
    "superficial",
    "supreme",
    "sure",
    "taboo",
    "tan",
    "tasteful",
    "tawdry",
    "telling",
    "temporary",
    "terrific",
    "tested",
    "thoughtful",
    "tidy",
    "tiny",
    "top",
    "torpid",
    "tranquil",
    "trite",
    "ugly",
    "ultra",
    "unbecoming",
    "understood",
    "uneven",
    "unfair",
    "unlikely",
    "unruly",
    "unsightly",
    "untidy",
    "unwritten",
    "upbeat",
    "upper",
    "uppity",
    "upset",
    "upstairs",
    "uptight",
    "used",
    "useful",
    "utter",
    "uttermost",
    "vagabond",
    "vanilla",
    "various",
    "vengeful",
    "verdant",
    "violet",
    "volatile",
    "wanting",
    "wary",
    "wasteful",
    "weary",
    "weekly",
    "welcome",
    "western",
    "whole",
    "wholesale",
    "wiry",
    "wistful",
    "womanly",
    "wooden",
    "woozy",
    "wound",
    "wrong",
    "wry",
    "zany",
    "sacred",
    "unknown",
    "detailed",
    "ongoing",
    "prominent",
    "permanent",
    "diverse",
    "partial",
    "moderate",
    "contemporary",
    "intense",
    "widespread",
    "ultimate",
    "ideal",
    "adequate",
    "sophisticated",
    "naked",
    "dominant",
    "precise",
    "intact",
    "adverse",
    "genuine",
    "subtle",
    "universal",
    "resistant",
    "routine",
    "distant",
    "unexpected",
    "soviet",
    "blind",
    "artificial",
    "mild",
    "legitimate",
    "unpublished",
    "superior",
    "intermediate",
    "everyday",
    "dumb",
    "excess",
    "sexy",
    "fake",
    "monthly",
    "premature",
    "sheer",
    "generic",
    "insane",
    "contrary",
    "twin",
    "upcoming",
    "bottom",
    "costly",
    "indirect",
    "sole",
    "unrelated",
    "hispanic",
    "improper",
    "underground",
    "legendary",
    "reluctant",
    "beloved",
    "inappropriate",
    "corrupt",
    "irrelevant",
    "justified",
    "obscure",
    "profound",
    "hostile",
    "influential",
    "inadequate",
    "abstract",
    "timely",
    "authentic",
    "bold",
    "intimate",
    "straightforward",
    "rival",
    "right-wing",
    "racist",
    "symbolic",
    "unprecedented",
    "loyal",
    "talented",
    "troubled",
    "noble",
    "instant",
    "incorrect",
    "dense",
    "blond",
    "deliberate",
    "blank",
    "rear",
    "feminine",
    "apt",
    "stark",
    "alcoholic",
    "teenage",
    "vibrant",
    "humble",
    "vain",
    "covert",
    "bland",
    "trendy",
    "foul",
    "populist",
    "alarming",
    "hooked",
    "wicked",
    "deaf",
    "left-wing",
    "lousy",
    "malignant",
    "stylish",
    "upscale",
    "hourly",
    "refreshing",
    "cozy",
    "slick",
    "dire",
    "yearly",
    "inbred",
    "part-time",
    "finite",
    "backwards",
    "nightly",
    "unauthorized",
    "cheesy",
    "indoor",
    "surreal",
    "bald",
    "masculine",
    "shady",
    "spirited",
    "eerie",
    "horrific",
    "smug",
    "stern",
    "hefty",
    "savvy",
    "bogus",
    "elaborate",
    "gloomy",
    "pristine",
    "extravagant",
    "serene",
    "advanced",
    "perverse",
    "devout",
    "crisp",
    "rosy",
    "slender",
    "melancholy",
    "faux",
    "phony",
    "danish",
    "lofty",
    "nuanced",
    "lax",
    "adept",
    "barren",
    "shameful",
    "sleek",
    "solemn",
    "vacant",
    "dishonest",
    "brisk",
    "fluent",
    "insecure",
    "humid",
    "menacing",
    "moot",
    "soothing",
    "self-loathing",
    "far-reaching",
    "harrowing",
    "scathing",
    "perplexing",
    "calming",
    "unconvincing",
    "unsuspecting",
    "unassuming",
    "surprising",
    "unappealing",
    "vexing",
    "unending",
    "easygoing",
    "appetizing",
    "disgruntled",
    "retarded",
    "undecided",
    "unregulated",
    "unsupervised",
    "unrecognized",
    "crazed",
    "distressed",
    "jagged",
    "paralleled",
    "cramped",
    "warped",
    "antiquated",
    "fabled",
    "deranged",
    "diseased",
    "ragged",
    "intoxicated",
    "hallowed",
    "crowded",
    "ghastly",
    "disorderly",
    "saintly",
    "wily",
    "sly",
    "sprightly",
    "ghostly",
    "oily",
    "hilly",
    "grisly",
    "earthly",
    "friendly",
    "unwieldy",
    "many",
    "most",
    "last",
    "expected",
    "far",
    "due",
    "divine",
    "all",
    "together",
    "only",
    "outside",
    "multiple",
    "appropriate",
    "evil",
    "favorite",
    "limited",
    "random",
    "republican",
    "okay",
    "essential",
    "secondary",
    "gay",
    "south",
    "pro",
    "northern",
    "urban",
    "acute",
    "prime",
    "arab",
    "overnight",
    "mixed",
    "crucial",
    "behind",
    "above",
    "beyond",
    "against",
    "under",
    "other",
    "less"
  ]



//////////////////
// WEBPACK FOOTER
// ./~/nlp_compromise/src/data/lexicon/adjectives.js
// module id = 293
// module chunks = 0